import React, { useEffect, useRef, useState } from "react";
import { useWindowWidth } from "@react-hook/window-size";
import c from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skeleton from "react-loading-skeleton";

import Search from "./search";
import { useMenu, getMonth } from "../providers/content";
import { getLocation } from "../util/url";
import { useLocalStorage } from "../util/useLocalStorage";

import css from "./layout.module.scss";

const randomPlaceholderWidth = () => {
  return `${Math.random() * 50 + 50}px`;
};


const SnowflakeAnmimation = () => {
  const [showSnowflakeAnmimation, setShowSnowflakeAnmimation] = useLocalStorage("mebm-snowflake-anmimation", true);
  const month = getMonth();
  // const [showSnowflakeAnmimation, setShowSnowflakeAnmimation] = useState(true);

  if ([12].indexOf(parseInt(month)) === -1) {
    return null;
  }

  return (
    <>
      <div
        className={c("custom-control custom-switch border-top border-left", css["snowflake-animation-toggler"])}
        onClick={() => {
          setShowSnowflakeAnmimation(!showSnowflakeAnmimation);
        }}
      >
        <input
          type="checkbox"
          className="custom-control-input"
          id="snowflake-animation-switch"
          checked={showSnowflakeAnmimation !== false}
        />
        <label className="custom-control-label" htmlFor="snowflakeAnimationSwitch">
          Schneeflocken
        </label>
      </div>
      {showSnowflakeAnmimation !== false && (
        <div className={css["snowflake-animation"]}>
          <div className={css["snowflakes"]} aria-hidden="true">
            <div className={css["snowflake"]}>❅</div>
            <div className={css["snowflake"]}>❅</div>
            <div className={css["snowflake"]}>❆</div>
            <div className={css["snowflake"]}>❄</div>
            <div className={css["snowflake"]}>❅</div>
            <div className={css["snowflake"]}>❆</div>
            <div className={css["snowflake"]}>❄</div>
            <div className={css["snowflake"]}>❅</div>
            <div className={css["snowflake"]}>❆</div>
            <div className={css["snowflake"]}>❄</div>
          </div>
        </div>
      )}
    </>
  );
};


export default SnowflakeAnmimation;